import { selectUserOrgByApp } from '@rsos/sinatra';
import { getIssues } from '../../services/capstone';
import {
  FETCH_ISSUES_START,
  FETCH_ISSUES_SUCCESS,
  FETCH_ISSUES_FAILED,
} from '../actionTypes';

export const fetchIssuesStart = () => ({
  type: FETCH_ISSUES_START,
});

export const fetchIssuesSuccess = issues => ({
  type: FETCH_ISSUES_SUCCESS,
  issues,
});

export const fetchIssuesFailed = error => ({
  type: FETCH_ISSUES_FAILED,
  error,
});

/**
 * Fetches the issues for the current psap.
 */
const fetchIssues = () => (dispatch, getState) => {
  const { sinatra } = getState();
  const application = sinatra.user.currentRole.application;
  const org = selectUserOrgByApp(sinatra, application);

  dispatch(fetchIssuesStart());
  return getIssues(org.name)
    .then(issues => {
      return dispatch(fetchIssuesSuccess(issues));
    })
    .catch(error => {
      throw dispatch(fetchIssuesFailed(error));
    });
};

export default fetchIssues;
